import React, {useEffect, useState} from 'react';
import classNames from "classnames";


import AudioButton from "../common/AudioButton/AudioButton";
import ConfirmButton from "../common/ConfirmButton/ConfirmButton";
import { ImageCard } from "../common/ImageCard/ImageCard";
import { Controls } from "../../Controls";

import {ActivityStateType, MatchingPairsProps} from "./MatchingPairs.type";

import './styles.scss';

export const MatchingPairs: React.FC<MatchingPairsProps> = ({
  images,
  audio,
  controls,
}) => {
  const [selectedAudio, setSelectedAudio] = useState<string | null>(null);
  const [matchingImage, setMatchingImage] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [matchingAudio, setMatchingAudio] = useState<string | null>(null);

  const [optionIsSelected, setOptionIsSelected] = useState<boolean>(false);
  const [selectedIsCorrect, setSelectedIsCorrect] = useState<boolean>(false);
  const [checkIsDone, setCheckIsDone] = useState<boolean>(false);
  const [currentlyPlayingAudio, setCurrentlyPlayingAudio] = useState<string>('');

  const [activityState, setActivityState] = useState<ActivityStateType>();

  useEffect(() => {
    setActivityState({
      audio: audio.map(item => ({
        ...item,
          isSelected: false,
          isCorrect: false,
      })),
      images: images.map(item => ({
        ...item,
        isSelected: false,
        isCorrect: false,
      })),
    })
  }, [audio, images])


  const onImageSelect = ({ selected, matching }: { selected: string, matching: string }) => {
    setCheckIsDone(false);

    setSelectedImage(selected);
    setMatchingAudio(matching);
    setOptionIsSelected(selectedAudio !== null);

    const updatedImages = activityState?.images.map(item => {
      return {
        ...item,
        isSelected: item.path === selected,
      };
    });

    // @ts-ignore
    setActivityState(prevState  => ({
      ...prevState,
      images: updatedImages,
    }));
    console.log('updatedImages', updatedImages);
  }

  const onAudioSelect = ({ selected, matching }: { selected: string, matching: string }) => {
    setCheckIsDone(false);

    setSelectedAudio(selected);
    setMatchingImage(matching);
    setOptionIsSelected(selectedImage !== null);

    const updatedAudio = activityState?.audio.map(item => {
      return {
        ...item,
        isSelected: item.path === selected,
      };
    });

    // @ts-ignore
    setActivityState(prevState  => ({
      ...prevState,
      audio: updatedAudio,
    }));
    console.log('updatedAudio', updatedAudio);
  }

  const onConfirmClick = () => {
    const isCorrect = selectedAudio === matchingAudio && selectedImage === matchingImage;
    setSelectedIsCorrect(isCorrect);
    setCheckIsDone(true);

    // @ts-ignore
    setActivityState(prevState  => ({
      ...prevState,
      images: prevState?.images.map(item => {
        return {
          ...item,
          isCorrect: item.isCorrect || (item.path === selectedImage && isCorrect),
        }
      }),
      audio: prevState?.audio.map(item => {
        return {
          ...item,
          isCorrect: item.isCorrect || (item.path === selectedAudio && isCorrect),
        }
      }),
    }));

    if (isCorrect) {
      setSelectedAudio(null);
      setSelectedImage(null);
      // setCheckIsDone(false);
    }
  };

  const resetSelection = () => {
    setSelectedImage(null);
    setOptionIsSelected(false);
    setSelectedIsCorrect(false);
    setCheckIsDone(false);
  };

  const { handlePrev, handleNext, currentIndex, lastItemIndex } = controls;

  const handleNextClick = () => {
    setCheckIsDone(false);
    handleNext();
  }

  const [showCorrectStatus, setShowCorrectStatus] = useState<boolean>(false);


  return (
    <>
      <div className={classNames("ActivityContainer MatchingPairs", {
        // "CheckIsDone": checkIsDone,
      })}>
        <div className="AudioContainer">
          {!!activityState?.audio.length && activityState.audio.map(item =>
            <AudioButton
              key={item.path}
              src={item.path}
              isRadio={true}
              currentlyPlayingAudio={currentlyPlayingAudio}
              setCurrentlyPlayingAudio={setCurrentlyPlayingAudio}
              isSelected={item.isSelected}
              onSelect={() => onAudioSelect({ selected: item.path, matching: item.matchingPath })}
              selectedIsCorrect={item.isCorrect}
              checkIsDone={checkIsDone}
              currentIndex={currentIndex}
            />
          )}
        </div>
        <div className="ImagesButtonsContainer">
          {!!activityState?.images?.length && activityState.images.map(image =>
            <div className={classNames("ImageButtonContainer", {
              "isCorrect": image.isCorrect,
              "isIncorrect": checkIsDone && image.isSelected && !image.isCorrect,
            })}>
              <ImageCard
                key={image.path}
                path={image.path}
                isRadio={true}
                isSelected={selectedImage === image.path}
                onSelect={() => onImageSelect({ selected: image.path, matching: image.matchingPath })}
                selectedIsCorrect={selectedIsCorrect || image.isCorrect}
              />
              <ConfirmButton
                onConfirm={onConfirmClick}
                optionIsSelected={optionIsSelected && selectedImage === image.path && !!selectedAudio}
                selectedIsCorrect={image.isCorrect}
                setCheckIsDone={setCheckIsDone}
                resetSelection={resetSelection}
                checkIsDone={checkIsDone || image.isCorrect}
                showCorrectStatus={checkIsDone || image.isCorrect}
                // showCorrectStatus={image.isCorrect}
                setShowCorrectStatus={setShowCorrectStatus}
              />
            </div>
          )}
        </div>
      </div>
      <Controls handlePrev={handlePrev} handleNext={handleNextClick} currentIndex={currentIndex} lastItemIndex={lastItemIndex}/>
    </>
  );
};
